import { useQuery } from '@tanstack/react-query';

import * as TourInventoryService from '~/services/TourInventoryService';

export const inventoryQueryKeys = {
  all: ['tour-inventory'] as const,
  departure: (serviceId: string | undefined, departureId: string | undefined) =>
    [...inventoryQueryKeys.all, 'departure', serviceId ?? '', departureId ?? ''] as const,
  reservation: (reservationId: string | undefined) =>
    [...inventoryQueryKeys.all, 'reservation', reservationId ?? ''] as const,
};

/** Inventory is keyed by service and departure, so both are required to run. */
export function useGetDepartureInventory(service: { serviceId?: string; departureId?: string }) {
  const { serviceId, departureId } = service;

  return useQuery({
    queryKey: inventoryQueryKeys.departure(serviceId, departureId),
    queryFn: ({ signal }) => TourInventoryService.getDepartureInventory({ serviceId, departureId }, { signal }),
    enabled: !!serviceId && !!departureId,
  });
}

export function useGetReservationInventory(reservationId: string | undefined) {
  return useQuery({
    queryKey: inventoryQueryKeys.reservation(reservationId),
    queryFn: ({ signal }) => TourInventoryService.getReservationInventory(reservationId, { signal }),
    enabled: !!reservationId,
  });
}
